import './delay_render_chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.TimelineChartView extends Backbone.View

  initialize: ({@times, @series, @chartOptions = {}}) ->

  renderChart: =>
    new Highcharts.Chart($.extend(true, @_highchartsOptions(), @chartOptions))

  _highchartsOptions: ->
    initialTime = new Date(_.min(@times) * 1000).setUTCHours(0, 0, 0)

    datetimeFormat = '%d-%m-%y'
    millisecondsInADay = 24 * 3600 * 1000

    {
      title:
        text: null
      chart:
        renderTo: @$el[0]
        type: 'line'
        zoomType: 'x'
        height: 300
      legend:
        enabled: @series.length > 1
      plotOptions:
        line:
          marker:
            enabled: @times.length == 1
            states:
              hover:
                enabled: true
          pointInterval: millisecondsInADay
          turboThreshold: 0
          pointStart: initialTime
          events: click: (event) => @trigger('timeline:click:line', event.point.id, event.point.time)
      xAxis:
        type: 'datetime'
        dateTimeLabelFormats:
          day: datetimeFormat
        crosshair:
          width: 1
      yAxis:
        title: null
        gridLineWidth: 0
      series: @series
      exporting:
        buttons:
          contextButton:
            enabled: false
      tooltip:
        dateTimeLabelFormats:
          day: datetimeFormat
    }
